import { render } from "./SquadDutyList.vue?vue&type=template&id=c184869e"
import script from "./SquadDutyList.vue?vue&type=script&lang=js"
export * from "./SquadDutyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__